







































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import StorePersetujuanTransfusiInkompatibel from "@/store/modules/PersetujuanTransfusiInkompatibel";
import SvcPersetujuanTransfusiInkompatibel from "@/services/PersetujuanTransfusiInkompatibel";
import { storeHasilPemeriksaanDarah } from "@/store/modules/HasilPemeriksaanDarahStore";
import BaseCardSuketMultiple from "@/components/pemeriksaan/resumeSuketV2/BaseCardSuketMultiple.vue";
import BerkasPersetujuanDarah from "./BerkasPersetujuanDarah.vue";
import PersetujuanTransfusiInkompatibelInputCard from "./PersetujuanTransfusiInkompatibelInputCard.vue";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { labelJk } from "@/utils/jenisKelamin";

@Component({
  components: {
    BerkasPersetujuanDarah,
    BaseCardSuketMultiple,
    PersetujuanTransfusiInkompatibelInputCard
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PersetujuanTransfusiInkompatibelTabPage extends Vue {
  @Prop() readonly register!: string;

  @Prop({ type: Number, default: null }) readonly prefillHasilId!: number | null;

  @Prop({ type: Boolean, default: false }) readonly bukaForm!: boolean;

  @Prop({ type: Boolean, default: false }) readonly sembunyikanTambah!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  expandInput = false;
  pageTab = "tab-soap";
  dataSuketActive: any = null;
  prefillAktif: number | null = null;

  hubunganOptions = [
    { value: "diri_sendiri", text: "Diri Sendiri" },
    { value: "istri", text: "Isteri" },
    { value: "suami", text: "Suami" },
    { value: "anak", text: "Anak" },
    { value: "ibu", text: "Ibu" },
    { value: "ayah", text: "Ayah" },
    { value: "lainnya", text: "Lainnya" }
  ];

  mounted() {
    if (
      StorePersetujuanTransfusiInkompatibel.registerId !== String(this.register)
    ) {
      StorePersetujuanTransfusiInkompatibel.getSuketByRegister(this.register);
    }

    storeHasilPemeriksaanDarah.loadKatalog();

    if (storeHasilPemeriksaanDarah.registerId !== String(this.register)) {
      storeHasilPemeriksaanDarah.getByRegister(this.register);
    }

    this.prefillAktif = this.hasilDasar;

    if (this.bukaForm && !this.readOnly) {
      this.dataSuketActive = null;
      this.expandInput = true;
    }
  }

  get hasilDasar(): number | null {
    return this.prefillHasilId ? Number(this.prefillHasilId) : null;
  }

  get dataSuket(): any[] {
    return StorePersetujuanTransfusiInkompatibel.suket
      .filter(item => this.milikLembarIni(item))
      .map(item => ({
        ...item,
        dokter_id: item.signee_user_id,
        dokter: item.signee
      }));
  }

  milikLembarIni(item: any): boolean {
    if (!this.hasilDasar) return true;

    const hasilId = this.sumberHasilId(item);

    return hasilId === null || hasilId === this.hasilDasar;
  }

  sumberHasilId(item: any): number | null {
    const sumber = item && item.content && item.content.sumber_hasil;

    return sumber && sumber.hasil_id ? Number(sumber.hasil_id) : null;
  }

  get bolehTambah(): boolean {
    if (!this.hasilDasar) return true;

    return !StorePersetujuanTransfusiInkompatibel.suket.some(
      item => this.sumberHasilId(item) === this.hasilDasar
    );
  }

  get loadContent() {
    return StorePersetujuanTransfusiInkompatibel.loading;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  isi(slotProps: any) {
    return (slotProps && slotProps.content) || {};
  }

  pembuat(slotProps: any) {
    return this.isi(slotProps).pembuat_pernyataan || {};
  }

  cm(slotProps: any) {
    return this.isi(slotProps).crossmatch || {};
  }

  labelJenisKelamin(nilai: any): string {
    return labelJk(nilai) || "-";
  }

  labelHubungan(pembuat: any) {
    const kode = pembuat && pembuat.hubungan;
    if (!kode) return "-";

    if (kode === "lainnya") {
      return pembuat.hubungan_lain || "Lainnya";
    }

    const found = this.hubunganOptions.find(o => o.value === kode);

    return found ? found.text : kode;
  }

  tglSurat(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
  }

  setActive(data) {
    this.dataSuketActive = data;
  }

  edit(data) {
    this.dataSuketActive = data;
    this.prefillAktif = null;
    this.showInput();
  }

  add() {
    this.dataSuketActive = null;
    this.prefillAktif = this.hasilDasar;
    this.showInput();
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SvcPersetujuanTransfusiInkompatibel.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.dataSuketActive = null;
    this.prefillAktif = null;
  }

  muatUlang() {
    StorePersetujuanTransfusiInkompatibel.getSuketByRegister(this.register);
  }

  setJumlahBerkas(payload: { id: number; jumlah: number }) {
    StorePersetujuanTransfusiInkompatibel.SET_SUKET(
      StorePersetujuanTransfusiInkompatibel.suket.map(s => (s.id === payload.id ? { ...s, berkas_count: payload.jumlah } : s))
    );
  }

  remove(item) {
    SvcPersetujuanTransfusiInkompatibel.destroy(item.id).then(dt => {
      if (dt.status == 1) {
        appModule.NoticeDelay(
          "Berhasil Hapus Persetujuan Transfusi Darah Inkompatibel"
        );
        StorePersetujuanTransfusiInkompatibel.getSuketByRegister(this.register);
      } else {
        appModule.sendErrorAlert(dt.message);
      }
    });
  }
}
